export default __webpack_public_path__ + "static/step3@2x-fdf5f065d91ae7335e30323f8f802746.png";